import useFacilityLscData from '../../../state/facility/facilityLsc/UseFacilityLscData';

import Dropdown from '../Dropdown';

import global from '../../GlobalStyle.module.css';

const FacilityLscDropdown = ({ label, name, value, error, message, onChange, facilityId, setDefaults }) => {
  const { facilityLscState } = useFacilityLscData(facilityId);

  return facilityLscState.message
    ? <span className={global.LoadingMsg}>{facilityLscState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={facilityLscState.options}
        name={name}
        value={value}
        onChange={onChange}
        areValuesIntegers={true}
        setDefaults={setDefaults}
        isLoading={facilityLscState.isArrayLoading} />
    );
};

export default FacilityLscDropdown;
